import api from './api'

export const categoriesService = {
  getTree: async () => {
    const res = await api.get('/categories')
    return res.data.data
  },

  getBySlug: async (slug) => {
    const res = await api.get(`/categories/${slug}`)
    return res.data.data
  },

  create: async (data) => {
    const res = await api.post('/categories', data)
    return res.data.data
  },

  update: async (id, data) => {
    const res = await api.patch(`/categories/${id}`, data)
    return res.data.data
  },

  delete: async (id) => {
    await api.delete(`/categories/${id}`)
  },
}
